import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TagCommanderService } from "ngx-tag-commander";
import { catchError, firstValueFrom, throwError } from "rxjs";

type OpenBankingEnv = "local" | "dev" | "preprod";
type OpenBankingBackendOrigin =
  | "https://dev-api.onbadi.com/open-banking"
  | "https://pprd-api.onbadi.com/open-banking"
  | "/api/dev/open-banking"
  | "/api/preprod/open-banking"
  | "http://localhost:4200"
  | (string & {});

type OpenBankingFrontendOrigin =
  | "https://case-widget.dev.openbanking.bank.oney.fr"
  | "https://case-widget.pprd.openbanking.bank.oney.fr"
  | (string & {});

@Component({
  selector: "app-submit-url",
  templateUrl: "./submit-url.component.html",
})
export class SubmitUrlComponent implements OnInit {
  openBankingEnv: OpenBankingEnv = "dev";
  openBankingFrontendOrigin: OpenBankingFrontendOrigin = "";
  openBankingLocalFrontendOrigin: string = "";
  openBankingBackendOrigin: OpenBankingBackendOrigin = "";
  azureToken = "";
  externalReference = (Math.floor(Math.random() * (999999 - 1)) + 1).toString();
  financingAmount = 1234;
  firstName = "John";
  lastName = "Doe";
  restoreUrl = window.origin.includes("localhost")
    ? "http://localhost:4400/restore-journey"
    : "https://widget-integration.openbanking.bank.oney.fr/restore-journey";
  isLoading = false;
  fakeOpenBankingFrontendRouteWhenMocking =
    "/init/vXavuWFtt?user-token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7InVpZCI6InZYYXZ1V0Z0dCJ9LCJwZXJtaXNzaW9ucyI6eyJyZWFkIjoic2VsZiIsIndyaXRlIjoic2VsZiJ9LCJpYXQiOjE3MjE5ODU1ODEsImV4cCI6MTcyMjI0NDc4MX0.AaLgTO6Y31vTkfS0JzBJER71EBCR_9H6OmRic5qb9Cc&tagging=eyJlbnZfYnVzaW5lc3MiOiJiMmIyYyIsImVudl9jaGFubmVsIjoid2ViIiwiZW52X3NpdGUiOiJzdWJzY3JpcHRpb24iLCJpZF9jbGllbnQiOiIxMTExMTExIiwicHJvZF9uYW1lIjoiZmluYW5jZW1lbnRfc2V1bCIsInByb2RfZmFtaWx5Ijoib25lIiwicGF5bWVudF90ZXJtIjoiMjB4Iiwic3RvcmVfaWQiOiIxMjM0NSIsInN0b3JlX25hbWUiOiJFbGVjdHJvIERlcG90Iiwic2l0ZV9sZXZlbDIiOiJmciIsInVzZXJfaWQiOiIyMjIyMjIyIiwidXNlcl9zdGF0dXMiOiJwdWJsaWMiLCJ4dHNpdGUiOiI1MTk3ODAiLCJlbnZfYXBwbGljYXRpb24iOiJvcGVuX2JhbmtpbmciLCJmb3JtX2ZvbGRlcl9udW1iZXIiOiI5ODY3NTY0OTIyMzc0NDYwMDAwIiwiZm9ybV9hbW91bnRfcHJvZHVjdGlvbiI6MjIyMiwiaWRfb3BlbmJhbmtpbmciOiJ2WGF2dVdGdHQifQ=&redirectPostWebauthToPartner=true";

  constructor(
    private readonly router: Router,
    private readonly httpClient: HttpClient,
    private readonly activatedRoute: ActivatedRoute,
    private readonly tagCommander: TagCommanderService
  ) {}

  async ngOnInit() {
    this.initStore();
    await this.initAccessToken();
    await this.initTagCommander();
  }

  onEnvChange(value: string) {
    if (value === "local") {
      this.openBankingLocalFrontendOrigin = JSON.parse(
        localStorage.getItem("OPEN_BANKING_LOCAL_FRONT_END_ORIGIN") || ""
      );
    }
  }

  /*
    There is a script which generates access_token from the backend 
    and adds it as a query param. It couldn't be done here for security 
    reason.
   */
  private async initAccessToken() {
    const { access_token } = await firstValueFrom(
      this.activatedRoute.queryParams
    );

    if (access_token) {
      this.azureToken = access_token;
    }

    return;
  }

  private async initTagCommander() {
    const containers = [
      {
        id: "tc-container-abtasty",
        uri: "https://cdn.tagcommander.com/2027/uat/tc_Oney_8.js",
        node: "head",
      },
      {
        id: "tc-container-analytics",
        uri: "https://cdn.tagcommander.com/2027/uat/tc_Oney_5.js",
        node: "body",
      },
      {
        id: "tc-container-media",
        uri: "https://cdn.tagcommander.com/2027/uat/tc_Oney_6.js",
        node: "body",
      },
    ];

    //@ts-ignore
    window["tc_vars"] = [];

    this.tagCommander.setTcVars({
      env_business: "b2b2c",
      env_channel: "web",
      env_site: "subscription",
      id_client: "345347843",
      prod_name: "financement_seul",
      prod_family: "one",
      payment_term: "20x",
      store_id: "12345",
      store_name: "cultura",
      site_level2: "fr",
      user_id: "1003206229",
      user_status: "public",
      xtsite: "519780",
      env_application: "open_banking",
      form_folder_number: "2158477717520679200",
      form_amount_production: 204902,
      id_openbanking: "jVYAADBrR",
      env_work: "qlf",
      page_language: "fr",
      error_page: "",
      error_type: "",
      error_category: "",
      click: "",
      page: "",
      page_chapter1: "",
      page_chapter2: "",
      page_chapter3: "",
      page_type: "",
    });

    await Promise.all(
      containers.map((container) =>
        this.tagCommander.addContainer(
          container.id,
          container.uri,
          container.node
        )
      )
    );

    console.log("TagCommander initialized");
    return;
  }

  onUrlSubmit() {
    this.isLoading = true;

    if (this.openBankingEnv === "local") {
      localStorage.setItem(
        "OPEN_BANKING_LOCAL_FRONT_END_ORIGIN",
        JSON.stringify(this.openBankingLocalFrontendOrigin)
      );
      this.openBankingBackendOrigin = "http://localhost:4200";
      this.displayIframe(
        `${this.openBankingLocalFrontendOrigin}${this.fakeOpenBankingFrontendRouteWhenMocking}`
      );
      return;
    }

    this.setOpenBankingBackendOriginUrl();
    const restoreUrl = this.restoreUrl;

    this.httpClient
      .post<any>(
        this.openBankingBackendOrigin + "/context",
        {
          open_banking_context: {
            external_reference_code: "selling_case_id",
            external_reference: this.externalReference,
            financing_amount: this.financingAmount,
            navigation: {
              restore_url: restoreUrl,
            },
          },
          customer: {
            identity: {
              full_name: `${this.firstName} ${this.lastName}`,
              first_name: this.firstName,
              last_name: this.lastName,
            },
          },
          metadata: {
            tagging: {
              env_business: "b2b2c",
              env_channel: "web",
              env_site: "subscription",
              id_client: "345347843",
              prod_name: "financement_seul",
              prod_family: "one",
              payment_term: "20x",
              store_id: "12345",
              store_name: "cultura",
              site_level2: "fr",
              user_id: "1003206229",
              user_status: "public",
              xtsite: "519780",
            },
          },
        },
        {
          headers: {
            Authorization: `Bearer ${this.azureToken}`,
          },
        }
      )
      .pipe(
        catchError(() => {
          this.isLoading = false;
          return throwError(() => new Error(`Widget url generation failed`));
        })
      )
      .subscribe((data) => {
        if (window.location.origin.includes("localhost")) {
          const origin = "http://localhost:4300";
          this.openBankingFrontendOrigin = this.changeOriginForLocalDevelopment(
            origin,
            data.widgetUrl
          );
          this.displayIframe(this.openBankingFrontendOrigin);
          return;
        }

        this.displayIframe(data.widgetUrl);
        return;
      });

    return;
  }

  private setOpenBankingBackendOriginUrl() {
    if (this.openBankingEnv === "dev") {
      this.openBankingBackendOrigin = "https://dev-api.onbadi.com/open-banking";
      return;
    }

    this.openBankingBackendOrigin = "https://pprd-api.onbadi.com/open-banking";
  }

  private displayIframe(widgetUrl: string) {
    this.isLoading = false;
    localStorage.setItem("WIDGET_URL", JSON.stringify(widgetUrl));
    localStorage.setItem(
      "EXTERNAL_REFERENCE",
      JSON.stringify(this.externalReference)
    );
    localStorage.setItem(
      "OPEN_BANKING_USER_TOKEN",
      JSON.stringify(this.azureToken)
    );
    localStorage.setItem(
      "OPEN_BANKING_BACKEND_ORIGIN",
      JSON.stringify(this.openBankingBackendOrigin)
    );

    this.router.navigate(["iframe"]);
    return;
  }

  private changeOriginForLocalDevelopment(
    origin: string,
    widgetUrl: string
  ): string {
    let widgetUrlWithoutDomain = widgetUrl.substring(
      widgetUrl.indexOf("/init")
    );
    return origin + widgetUrlWithoutDomain;
  }

  private initStore() {
    localStorage.removeItem("EXTERNAL_REFERENCE");
    localStorage.removeItem("OPEN_BANKING_USER_TOKEN");
    localStorage.removeItem("OPEN_BANKING_BACKEND_ORIGIN");
    localStorage.removeItem("WIDGET_URL");
  }
}
